/**
 * Utilitários de formatação compartilhados
 */

export function formatCPF(cpf: string): string {
  if (!cpf) return "";
  return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
}

export function formatPhone(phone: string): string {
  if (!phone) return "";
  if (phone.length === 11) {
    return phone.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  } else if (phone.length === 10) {
    return phone.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  }
  return phone;
}

export function formatDateBR(isoDate?: string): string {
  if (!isoDate) return "";
  const [year, month, day] = isoDate.split("-");
  return `${day}/${month}/${year}`;
}

export function formatCRO(cro: string): string {
  if (!cro) return "";
  cro = cro.trim().toUpperCase();
  
  if (/^[A-Z]{2}-\d{4,6}$/.test(cro)) return cro;
  
  const match = cro.match(/^([A-Z]{2})(\d{4,6})$/);
  if (match) {
    return `${match[1]}-${match[2]}`;
  }
  
  return cro;
}

export function onlyNumbers(str: string | null | undefined): string {
  if (!str) return "";
  return str.replace(/\D/g, "");
}

export function firstAndLastName(fullName: string): string {
  const parts = fullName.trim().split(" ");
  if (parts.length <= 1) return fullName;
  return `${parts[0]} ${parts[parts.length - 1]}`;
}

// Formata números de carteirinha, evitando notação científica como "9E+16"
export function formatCardNumber(value?: string | number | null): string {
  if (value === undefined || value === null) return "";
  const str = String(value).trim();

  // Se já estiver em formato comum, apenas retorna
  if (!/e\+/i.test(str)) return str;

  // Converte casos simples como "9E+16" para "90000000000000000"
  const sciMatch = str.match(/^(\d+)e\+(\d+)$/i);
  if (!sciMatch) return str;

  const base = sciMatch[1];
  const exp = parseInt(sciMatch[2], 10);
  if (Number.isNaN(exp)) return str;

  return base + "0".repeat(exp);
}

export function formatISODate(date: Date): string {
  return date.toISOString().split("T")[0];
}

export function formatCNPJ(cnpj: string): string {
  if (!cnpj) return "";
  return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
}

export function formatCEP(cep: string): string {
  if (!cep) return "";
  return cep.replace(/(\d{5})(\d{3})/, "$1-$2");
}
